import { Controller } from "stimulus";

class KarrotMapController extends Controller {
  static targets = ["map"]
  static values = {
    lat: Number,
    lng: Number,
    name: String
  }

  connect() {
    this.initMap()
  }

  initMap() {
    console.log("initMap")

    this.map = new karrotmaps.Map(this.mapTarget, {
      center: [this.lngValue, this.latValue],
      zoom: 13
    })
    this.buildMarker(this.latValue, this.lngValue, this.nameValue)
  }

  buildMarker(lat, lng, title) {
    const popup = new karrotmaps.Popup({
      closeButton: false,
      closeOnClick: false,
      anchor: 'bottom',
      focusAfterOpen: false,
      maxWidth: '300px',
    }).setLngLat([this.lngValue, this.latValue]).setText(title)

    const marker = new karrotmaps.Marker()
      .setLngLat([this.lngValue, this.latValue])
      .setPopup(popup)
    this.map.addMarker(marker)
    this.map.once('load', () => {marker.togglePopup()})

    return marker
  }
}

export default KarrotMapController;